<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-11-17 15:58:50
 * @LastEditors: xgx
 * @LastEditTime: 2023-03-28 12:19:08
-->
<template>
  <a-spin :spinning="loading">
    <div class="cont-box">
      <div v-for="(item, index) in dataContent">
        <div class="box-one">
          <div class="xian-card">
            <div class="left"></div>
            <div class="right-card">
              <div class="title-one">{{ index + 1 }}. {{ item.textName }}</div>
              <div class="rideo-box" v-for="itemTwo in item.optionContent">
                <div>
                  <div class="title-two">
                    <el-radio v-if="item.type == 0" disabled v-model="radio"
                      ><span class="title-txt">{{
                        itemTwo.content
                      }}</span></el-radio
                    >
                    <el-checkbox
                      v-if="item.type == 1"
                      disabled
                      v-model="checked"
                      ><span class="title-txt">{{
                        itemTwo.content
                      }}</span></el-checkbox
                    >
                  </div>
                </div>
                <div class="progress-box">
                  <div
                    v-if="itemTwo.optionTotal > 0"
                    :style="{
                      width:
                        (itemTwo.optionTotal / itemTwo.proportionTotal) * 100 +
                        '%',
                    }"
                    class="now-pro"
                  >
                    <span style="margin-right: 6px"
                      >{{ itemTwo.optionTotal }}/{{
                        itemTwo.proportionTotal
                      }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </a-spin>
</template>

<script>
import { findListProportion } from "../index";
export default {
  data() {
    return {
      radio: "2",
      checked: "2",
      isCollectId: this.$route.query.isCollectId,
      dataContent: [],
      loading: false,
    };
  },
  components: {},
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      findListProportion({
        id: this.isCollectId,
      }).then((res) => {
        if (res.code == 0) {
          this.dataContent = res.data;
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.cont-box {
  padding-left: 24px;
  overflow-y: auto;
  height: 767px;
  margin-top: 24px;
  .title-one {
    color: rgba(16, 16, 16, 1);
    font-size: 14px;
    font-family: HarmonyOS_Sans_SC-regular;
    margin-bottom: 14px;
    overflow: hidden; //超出的文本隐藏
    text-overflow: ellipsis; //溢出用省略号显示
    white-space: nowrap; // 默认不换行；
    width: 480px;
  }
  .rideo-box {
    display: flex;
    margin-top: 10px;
  }
  .title-two {
    font-size: 14px;
    text-align: left;
    font-family: Roboto-regular;
  }
}
.box-one {
  display: flex;
  margin-bottom: 14px;
  .left {
    width: 4px;
    height: 100%;
    background-color: rgba(95, 184, 120, 1);
  }
}
.xian-card {
  background-color: rgba(242, 242, 242, 1);
  display: flex;
}
.right-card{
  padding: 14px;
}
/deep/ .el-radio__input.is-disabled .el-radio__inner,
.el-radio__input.is-disabled.is-checked .el-radio__inner {
  background-color: #fff !important;
}
/deep/ .el-avatar,
.el-cascader-panel,
.el-radio,
.el-radio--medium.is-bordered .el-radio__label,
.el-radio__label {
  font-size: 16px;
}
/deep/ .el-radio__inner {
  width: 16px;
  height: 16px;
}
.title-txt {
  color: rgba(48, 49, 51, 1);
  font-size: 14px;
  font-family: Roboto-regular;
  overflow: hidden; //超出的文本隐藏
  text-overflow: ellipsis; //溢出用省略号显示
  white-space: nowrap; // 默认不换行；
  width: 107px;
  display: block;
}
/deep/ .el-checkbox__input.is-disabled .el-checkbox__inner {
  background: #fff !important;
}
.progress-box {
  width: 320px;
  height: 22px;
  line-height: 20px;
  background-color: rgba(226, 226, 226, 1);
  margin-left: 28px;
}
.now-pro {
  height: 100%;
  line-height: 20px;
  background-color: rgba(95, 184, 120, 1);
  text-align: right;
  color: #fff;
}
/deep/ .el-radio {
  display: flex;
}
/deep/ .el-checkbox {
  display: flex;
  align-items: center;
}
</style>